import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "custom-modal-wrap overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-[100] md:inset-0 h-modal md:h-full justify-center items-center flex" }
const _hoisted_2 = { class: "relative pt-[80px] pb-[80px] grid items-center p-4 w-full h-full md:h-[100vh] max-w-[820px]" }
const _hoisted_3 = { class: "relative rounded-xl shadow bg-theme-modalbg" }
const _hoisted_4 = {
  class: "grid grid-cols-1 lg:grid-cols-1 gap-3",
  style: {"font-family":"Arial"}
}
const _hoisted_5 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_6 = { class: "w-[800px] rounded-2xl shadow-[0px_25px_50px_-12px_rgba(0,0,0,1.00)] inline-flex flex-col justify-start items-center overflow-hidden" }
const _hoisted_7 = { class: "self-stretch px-6 py-4 bg-green-500 inline-flex justify-start items-start gap-6" }
const _hoisted_8 = { class: "flex justify-end items-center gap-4" }
const _hoisted_9 = { class: "self-stretch px-6 pt-6 bg-zinc-800 flex flex-col justify-start items-start gap-6 h-[600px] overflow-y-auto" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "self-stretch inline-flex justify-start items-start gap-4" }
const _hoisted_12 = { class: "flex-1 inline-flex flex-col justify-start items-start gap-1" }
const _hoisted_13 = { class: "self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md inline-flex justify-start items-center gap-2" }
const _hoisted_14 = {
  class: "cursor-pointer flex items-center w-full",
  for: "primary_color"
}
const _hoisted_15 = { class: "flex-1 text-white text-base font-normal font-['Roboto'] leading-5" }
const _hoisted_16 = { class: "flex-1 inline-flex flex-col justify-start items-start gap-1" }
const _hoisted_17 = { class: "self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md inline-flex justify-start items-center gap-2" }
const _hoisted_18 = {
  class: "cursor-pointer flex items-center w-full",
  for: "secondary_color"
}
const _hoisted_19 = { class: "flex-1 text-white text-base font-normal font-['Roboto'] leading-5" }
const _hoisted_20 = { class: "self-stretch flex flex-col justify-start items-start gap-4" }
const _hoisted_21 = { class: "self-stretch inline-flex justify-start items-start gap-4" }
const _hoisted_22 = { class: "flex-1 inline-flex flex-col justify-start items-start gap-1" }
const _hoisted_23 = { class: "relative w-full flex flex-row justify-between" }
const _hoisted_24 = {
  key: 1,
  class: "w-full h-[201px] flex items-center justify-center relative z-1"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "flex-1 inline-flex flex-col justify-start items-start gap-1" }
const _hoisted_28 = { class: "relative w-full flex flex-row justify-between" }
const _hoisted_29 = {
  key: 1,
  class: "w-full h-[201px] flex items-center justify-center relative z-1"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "self-stretch w-full px-0 py-0" }
const _hoisted_33 = { class: "flex items-center cursor-pointer" }
const _hoisted_34 = { class: "self-stretch flex flex-col justify-start items-start gap-4" }
const _hoisted_35 = { class: "self-stretch inline-flex justify-start items-start gap-4" }
const _hoisted_36 = { class: "flex-1 inline-flex flex-col justify-start items-start gap-1" }
const _hoisted_37 = { class: "flex-1 inline-flex flex-col justify-start items-start gap-1" }
const _hoisted_38 = { class: "self-stretch inline-flex justify-start items-start gap-4" }
const _hoisted_39 = { class: "flex-1 inline-flex flex-col justify-start items-start gap-1" }
const _hoisted_40 = { class: "flex-1 inline-flex flex-col justify-start items-start gap-1" }
const _hoisted_41 = { class: "flex flex-col cursor-pointer items-start gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_manager = _resolveComponent("file-manager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex-1 self-stretch inline-flex flex-col justify-center items-center gap-0.5" }, [
                  _createElementVNode("div", { class: "self-stretch justify-center text-white text-xl font-bold font-['Roboto'] leading-6 tracking-tight line-clamp-1" }, "Edit Business Profile"),
                  _createElementVNode("div", { class: "self-stretch justify-center text-white text-sm font-normal font-['Roboto'] leading-4 line-clamp-1" }, "Set branding that will apply to all locations assigned to this business profile.")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePop && _ctx.closePop(...args))),
                    "data-configuration": "Text-L",
                    "data-fill": "True",
                    "data-show-icon": "False",
                    "data-state": "Default",
                    class: "w-24 h-11 p-4 rounded outline outline-1 outline-offset-[-1px] outline-white flex justify-center items-center gap-2"
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("div", { class: "text-center justify-center text-white text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest" }, "CANCEL", -1)
                  ]))]),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateBusinessProfile && _ctx.updateBusinessProfile(...args))),
                    "data-configuration": "Text-L",
                    "data-fill": "True",
                    "data-show-icon": "False",
                    "data-state": "Default",
                    class: "w-24 h-11 p-4 bg-white rounded flex justify-center items-center gap-2"
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("div", { class: "text-center justify-center text-green-500 text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest" }, "Update", -1)
                  ]))])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(["self-stretch flex flex-col justify-start items-start gap-4", 'input-wrapper ' + (_ctx.businessForm.name.error_type)])
                }, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "self-stretch justify-center text-white text-base font-bold font-['Roboto'] leading-5 tracking-tight" }, "Branding", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass('self-stretch flex flex-col justify-start items-start gap-1 ' + (_ctx.businessForm.name.error_type))
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", {
                      for: "business",
                      class: "self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4"
                    }, "Business Name *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "business",
                      onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateFields(['name']))),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.businessForm.name.value) = $event)),
                      class: "self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md text-white text-base font-normal font-['Roboto'] leading-5 border-2 focus:border-transparent outline-0 ring-0 focus:outline-0 focus:ring-0",
                      placeholder: "Business Name",
                      type: "text"
                    }, null, 544), [
                      [_vModelText, _ctx.businessForm.name.value]
                    ]),
                    (_ctx.businessForm.name.error_message)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "field-error text-red-500 text-xs mt-1",
                          textContent: _toDisplayString(_ctx.businessForm.name.error_message)
                        }, null, 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4" }, "Primary Color *", -1)),
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "color",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.primaryColor) = $event)),
                          class: "invisible w-0",
                          id: "primary_color"
                        }, null, 512), [
                          [_vModelText, _ctx.form.primaryColor]
                        ]),
                        _createElementVNode("label", _hoisted_14, [
                          _createElementVNode("div", {
                            class: "w-4 h-4 rounded-sm mr-2",
                            style: _normalizeStyle('background:' + (_ctx.form.primaryColor || '#FFFFFF'))
                          }, null, 4),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.form.primaryColor || '#FFFFFF'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4" }, "Secondary Color *", -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "color",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.secondaryColor) = $event)),
                          class: "invisible w-0",
                          id: "secondary_color"
                        }, null, 512), [
                          [_vModelText, _ctx.form.secondaryColor]
                        ]),
                        _createElementVNode("label", _hoisted_18, [
                          _createElementVNode("div", {
                            class: "w-4 h-4 rounded-sm mr-2",
                            style: _normalizeStyle('background:' + (_ctx.form.secondaryColor || '#FFFFFF'))
                          }, null, 4),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.form.secondaryColor || '#FFFFFF'), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "self-stretch inline-flex justify-start items-start gap-4" }, [
                      _createElementVNode("div", { class: "flex-1 justify-start text-white text-xs font-normal font-['Roboto'] leading-4" }, "Business Logo *"),
                      _createElementVNode("div", { class: "flex-1 justify-start text-white text-xs font-normal font-['Roboto'] leading-4" }, "Browser Favicon (optional)")
                    ], -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_file_manager, {
                          modelValue: _ctx.form.logo,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.logo) = $event)),
                          validFileTypes: ['image'],
                          class: _normalizeClass('flex cursor-pointer flex-col items-center justify-between rounded-md ' + (_ctx.form.logo ? ' border-zinc-700 border outline outline-1 outline-offset-[-1px]' : 'border-2  border-green-500 px-4 py-[21px] border-dashed' )),
                          label: "SELECT"
                        }, {
                          custom: _withCtx(({ onClick }) => [
                            _createElementVNode("div", _hoisted_23, [
                              (_ctx.form.logo)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "absolute hover:opacity-80 z-10 top-2 right-2 bg-red-700 text-[#fff] rounded-full h-[30px] w-[30px] flex justify-center items-center",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.logo = undefined))
                                  }, "×"))
                                : _createCommentVNode("", true),
                              (_ctx.form.logo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createElementVNode("img", {
                                      class: "w-auto h-full",
                                      src: _ctx.form.logo
                                    }, null, 8, _hoisted_25)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    onClick: onClick,
                                    class: "w-full"
                                  }, [...(_cache[21] || (_cache[21] = [
                                    _createElementVNode("div", { class: "w-full h-[115px] flex items-center justify-center" }, [
                                      _createElementVNode("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M19.3334 11.3332H11.3334V19.3332H8.66675V11.3332H0.666748V8.6665H8.66675V0.666504H11.3334V8.6665H19.3334V11.3332Z",
                                          fill: "#2BA66B"
                                        })
                                      ])
                                    ], -1),
                                    _createElementVNode("p", { class: "text-[#9E9E9E] text-center text-sm px-[12px]" }, "Please upload a high-quality image of your business logo in JPEG or PNG format", -1)
                                  ]))], 8, _hoisted_26))
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_file_manager, {
                          modelValue: _ctx.form.favicon,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.favicon) = $event)),
                          validFileTypes: ['image'],
                          class: _normalizeClass('flex cursor-pointer flex-col items-center justify-between rounded-md ' + (_ctx.form.favicon ? ' border-zinc-700 border outline outline-1 outline-offset-[-1px]' : 'border-2  border-green-500 px-4 py-[21px] border-dashed' )),
                          label: "SELECT"
                        }, {
                          custom: _withCtx(({ onClick }) => [
                            _createElementVNode("div", _hoisted_28, [
                              (_ctx.form.favicon)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "absolute hover:opacity-80 z-10 top-2 right-2 bg-red-700 text-[#fff] rounded-full h-[30px] w-[30px] flex justify-center items-center",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.favicon = undefined))
                                  }, "×"))
                                : _createCommentVNode("", true),
                              (_ctx.form.favicon)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createElementVNode("img", {
                                      class: "w-auto h-full",
                                      src: _ctx.form.favicon
                                    }, null, 8, _hoisted_30)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    onClick: onClick,
                                    class: "w-full"
                                  }, [...(_cache[22] || (_cache[22] = [
                                    _createElementVNode("div", { class: "w-full h-[115px] flex items-center justify-center" }, [
                                      _createElementVNode("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M19.3334 11.3332H11.3334V19.3332H8.66675V11.3332H0.666748V8.6665H8.66675V0.666504H11.3334V8.6665H19.3334V11.3332Z",
                                          fill: "#2BA66B"
                                        })
                                      ])
                                    ], -1),
                                    _createElementVNode("p", { class: "text-[#9E9E9E] text-center text-sm px-[12px]" }, "Please upload a square image in JPEG or PNG format for the best fit.", -1)
                                  ]))], 8, _hoisted_31))
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "font-bold text-base leading-5 tracking-[0.15px] h-[20px] mr-5 text-white" }, "Cash Rounding", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.cashRounding) = $event)),
                        class: "hidden peer"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.cashRounding]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass('relative toggle-bg border-2 h-6 w-11 rounded-full ' + (_ctx.form.cashRounding ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                      }, null, 2)
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("p", { class: "font-normal text-sm leading-[17.5px] my-3 text-neutral-300" }, "With cash rounding enabled, your cash payments will be rounded to the nearest .05.", -1))
                  ])
                ], 2),
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-zinc-700" }, null, -1)),
                _createElementVNode("div", _hoisted_34, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "self-stretch justify-center text-white text-base font-bold font-['Roboto'] leading-5 tracking-tight" }, "Website & Domain Settings", -1)),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4" }, "Merchant Website URL (optional)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.websiteForm.domain.value) = $event)),
                        class: "self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md text-white text-base font-normal font-['Roboto'] leading-5 border-0 focus:outline-none focus:ring-0",
                        placeholder: "https://example.com",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.websiteForm.domain.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4" }, "Logo Link (optional)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.websiteForm.logoLink.value) = $event)),
                        class: "self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md text-white text-base font-normal font-['Roboto'] leading-5 border-0 focus:outline-none focus:ring-0",
                        placeholder: "https://example.com/logo.png",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.websiteForm.logoLink.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4" }, "Google Analytics Tracking ID (optional)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.websiteForm.googleAnalyticsKey.value) = $event)),
                        class: "self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md text-white text-base font-normal font-['Roboto'] leading-5 border-0 focus:outline-none focus:ring-0",
                        placeholder: "UA-XXXXXXXXX-X",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.websiteForm.googleAnalyticsKey.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, [
                        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4" }, "Logo Open in New Tab", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.logoOpenInNewTab) = $event)),
                          class: "hidden peer"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.logoOpenInNewTab]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass('relative toggle-bg border-2 h-6 w-11 rounded-full ' + (_ctx.form.logoOpenInNewTab ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                        }, null, 2)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}